import { useEffect } from "react";

const CALENDLY_SCRIPT = "https://assets.calendly.com/assets/external/widget.js";

const SchedulerEmbed = ({ scheduler }) => {
  useEffect(() => {
    const initializeCalendly = () => {
      if (window.Calendly?.initInlineWidgets) {
        window.Calendly.initInlineWidgets();
      }
    };

    const existingScript = document.querySelector(`script[src="${CALENDLY_SCRIPT}"]`);
    if (existingScript) {
      if (window.Calendly?.initInlineWidgets) {
        initializeCalendly();
      } else {
        existingScript.addEventListener("load", initializeCalendly, { once: true });
      }
      return undefined;
    }

    const script = document.createElement("script");
    script.src = CALENDLY_SCRIPT;
    script.async = true;
    script.onload = initializeCalendly;
    document.body.appendChild(script);

    return () => {
      script.onload = null;
    };
  }, []);

  return (
    <div className="border border-black/10 bg-white p-6 md:p-8" data-testid="scheduler-embed-card">
      <div className="space-y-6">
        <div className="space-y-3">
          <p className="eyebrow" data-testid="scheduler-label">
            Live availability
          </p>
          <h3 className="text-2xl font-bold tracking-[-0.04em] text-[#0A0A0A]" data-testid="scheduler-title">
            {scheduler?.title}
          </h3>
          <p className="text-sm leading-7 text-[#52525B]" data-testid="scheduler-description">
            {scheduler?.description}
          </p>
        </div>
      </div>

      <div className="mt-10" data-testid="calendly-embed-section">
        <p className="text-sm leading-7 text-[#52525B]" data-testid="calendly-framing-line">
          Schedule a 30-minute exploratory conversation
        </p>

        <div className="mt-4 border border-black/10 bg-[#F8F8F6] p-2 md:p-3" data-testid="calendly-embed-wrapper">
          <div
            className="calendly-inline-widget w-full"
            data-url={scheduler?.calendly_url}
            style={{ minWidth: "320px", height: "760px" }}
            data-testid="calendly-inline-widget"
          />
        </div>

        <p className="mt-10 text-sm leading-7 text-[#52525B]" data-testid="scheduler-note">
          {scheduler?.note}
        </p>
      </div>
    </div>
  );
};

export default SchedulerEmbed;